import React from "react";
import '../css/default.css';
import { Text } from '../components';

const DEFAULT_CODE_LENGTH = 4;

export default class CodeInput extends React.Component {

  constructor(props) {
    super(props);

    this.input_refs = [];
    for (let i = 0; i < this.get_length(); i++) {
      this.input_refs.push(React.createRef());
    }
  }

  // Number of digit boxes; defaults to 4 (email sign-in), phone verification passes 6.
  get_length = () => {
    let length = parseInt(this.props.length, 10);
    return length > 0 ? length : DEFAULT_CODE_LENGTH;
  }

  componentDidMount() {
    if (this.props.autofocus && this.input_refs[0].current) {
      this.input_refs[0].current.focus();
    }
  }

  focus_input = (index) => {
    if (index >= 0 && index < this.get_length() && this.input_refs[index].current) {
      this.input_refs[index].current.focus();
    }
  }

  get_digits = () => {
    let value  = this.props.value || '';
    let digits = [];
    for (let i = 0; i < this.get_length(); i++) {
      digits.push(value[i] || '');
    }
    return digits;
  }

  set_digit = (index, digit) => {
    let digits    = this.get_digits();
    digits[index] = digit;
    this.props.onChange(digits.join(''));
  }

  handle_change = (index, event) => {
    let text = event.target.value.replace(/[^0-9]/g, '');

    if (text === '') {
      this.set_digit(index, '');
      return;
    }

    if (text.length > 1) {
      this.handle_paste_text(index, text);
      return;
    }

    this.set_digit(index, text);
    this.focus_input(index + 1);
  }

  handle_paste_text = (index, text) => {
    let digits = this.get_digits();
    let cursor = index;
    for (let i = 0; i < text.length && cursor < this.get_length(); i++) {
      digits[cursor] = text[i];
      cursor++;
    }
    this.props.onChange(digits.join(''));
    this.focus_input(Math.min(cursor, this.get_length() - 1));
  }

  handle_key_down = (index, event) => {
    let digits = this.get_digits();

    if (event.key === 'Backspace') {
      if (digits[index] === '' && index > 0) {
        this.set_digit(index - 1, '');
        this.focus_input(index - 1);
        event.preventDefault();
      }
    }

    if (event.key === 'ArrowLeft') {
      this.focus_input(index - 1);
      event.preventDefault();
    }

    if (event.key === 'ArrowRight') {
      this.focus_input(index + 1);
      event.preventDefault();
    }
  }

  render() {
    let hide_label  = this.props.hide_label ? true : false;
    let digits      = this.get_digits();
    let row_class   = this.props.row_class   || '';
    let input_class = this.props.input_class || 'mt-1 block rounded-md bg-gray-100 border-transparent focus:border-sky-300 focus:bg-white focus:ring-0';
    let input_style = this.props.input_class ? { ...this.props.style } : { fontFamily: 'Manrope', fontSize: 22, fontWeight: 'bold', borderWidth: 2, width: 55, textAlign: 'center', borderRadius: 12, height: 55, ...this.props.style, padding: 0 };

    return <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }}>
      { !hide_label ? <Text>Code Input</Text> : null }
      <div className={ row_class } style={ row_class ? {} : { display: 'flex', flexDirection: 'row', justifyContent: 'center', gap: this.props.gap || 12 } }>
        { digits.map((digit, index) => {
          return <input key={index}
                        ref={this.input_refs[index]}
                        type='tel'
                        inputMode='numeric'
                        autoComplete={ index === 0 ? 'one-time-code' : 'off' }
                        maxLength={this.get_length()}
                        value={digit}
                        style={ input_style }
                        className={ input_class + (digit ? ' is-filled' : '') }
                        onFocus={ (event) => {
                          event.target.select();
                        }}
                        onChange={ (event) => {
                          this.handle_change(index, event);
                        }}
                        onPaste={ (event) => {
                          event.preventDefault();
                          let text = (event.clipboardData.getData('text') || '').replace(/[^0-9]/g, '');
                          if (text) {
                            this.handle_paste_text(index, text);
                          }
                        }}
                        onKeyDown={ (event) => {
                          this.handle_key_down(index, event);
                        }} />
        }) }
      </div>
    </div>
  }
}
